import { createActions } from 'redux-actions';

export default createActions(
  {
    RESET: () => ({}),
    LOAD: (robots) => ({ robots }),
    ACTIVATE: (robotId) => ({ robotId }),
    DEACTIVATE: (robotId) => ({ robotId }),
    TOGGLE_SHOW: (robotId) => ({ robotId }),
    CHANGE_COLOR: (robotId, color) => ({ robotId, color }),
    UPDATE_VIDEO: (robotId, data) => ({ robotId, data }),
  },
  { prefix: 'ROBOTS' }
);
